<template>
  <v-container>
    <v-row justify="end">
      <v-btn class='mb-4' @click='onClick編集(null)'>
        <v-icon>
          mdi-plus
        </v-icon>
      </v-btn>
    </v-row>
    <template v-for='(row,index) in お客様の声rtn' :key='index'>
      <v-card class='mb-2'>
        <v-card-title>
          {{row.依頼内容}}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-rating
                hover
                :length="5"
                :size="32"
                v-model="row.評価"
                active-color="yellow"
                readonly
              >
              </v-rating>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              {{row.感想}}<br>
              {{row.created_at}}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click='onClick編集(row)'><v-icon>mdi-lead-pencil</v-icon>編集</v-btn>
          <v-btn @click='onClick削除(row)'><v-icon>mdi-trash-can</v-icon>削除</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-container>
  <v-dialog
    v-model="dialog"
  >
    <v-container>
      <v-card>
        <v-card-title>
          編集
        </v-card-title>
        <v-card-text>
          <v-row>
            <!--
            <v-col>
              <v-text-field
                type=date
                v-model='selectedRow.日付'
                label='日付'
              ></v-text-field>
            </v-col>
            -->
            <!--
            <v-col>
              <v-text-field
                v-model='selectedRow.名前'
                label='ニックネーム'
              ></v-text-field>
            </v-col>
            -->
            <v-col>
              <v-text-field
                v-model='selectedRow.依頼内容'
                label='依頼内容'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              評価：
              <v-rating
                hover
                :length="5"
                :size="32"
                v-model="selectedRow.評価"
                active-color="yellow"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                v-model='selectedRow.感想'
                label='感想'
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click='dialog=false' class='ml-5'><v-icon>mdi-arrow-left</v-icon>戻る</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click='onClick保存()'><v-icon>mdi-content-save</v-icon>保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-dialog>
</template>

<script>
  export default {
    data(){
      return {
        お客様の声rtn:[],
        dialog:false,
        selectedRow:{},
      }

    },

    mounted(){
      this.お客様の声取得();
    },

    methods:{
      お客様の声取得(){
        this.$emit('overlay');
        let url = '../api/api.php';
        let data = {
          func:"お客様の声取得",
          表示:"edit",
        };

        let param = {
            method : "POST",
            headers : { "Content-Type": "application/json" },
            body : JSON.stringify(data),
            }
        fetch(url,param)
        .then(response => {return response.text();})
        .then(result => {
          try {
            const jsonData = JSON.parse(result);
            return jsonData;
          }catch(e){
            return Promise.reject({body:result,type:'unparsable'})
          }
        })
        .then(result => {
          this.お客様の声rtn = result.お客様の声rtn;
          this.$emit('overlay');
        })
        .catch(error =>{
          console.log(error)
          alert('取得できませんでした。\n\n'+error.body);
          this.$emit('overlay');
        })
      },

      onClick編集(row){
        this.dialog = true
        if(row){
          this.selectedRow = row
        }else{
          this.selectedRow = {}
        }

      },

      onClick保存(){
        this.$emit('overlay');

        let url = '../api/api.php';
        let data = this.selectedRow;
        data.func="お客様の声保存"

        console.log("お客様の声Data",data)

        let param = {
            method : "POST",
            headers : { "Content-Type": "application/json" },
            body : JSON.stringify(data),
            }
        fetch(url,param)
        .then(response => {return response.text();})
        .then(result => {
          try {
            const jsonData = JSON.parse(result);
            return jsonData;
          }catch(e){
            return Promise.reject({body:result,type:'unparsable'})
          }
        })
        .then(result => {
          console.log(result);
          this.dialog = false;
          this.$emit('overlay');
          this.お客様の声取得()
        })
        .catch(error =>{
          console.log(error)
          alert('保存できませんでした。\n\n'+error.body);
          this.$emit('overlay');
        })
      },
      onClick閉じる(){

      },

    }
  }
</script>

  